import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import axios from 'axios'
import Qs from 'qs'
import VueCookies from 'vue-cookies'
import {Indicator} from 'mint-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueTouch from 'vue-touch'
import wx from 'weixin-js-sdk'
import {Toast} from 'vant'
import 'mint-ui/lib/style.css'
import 'swiper/dist/css/swiper.css'

Vue.config.productionTip = false

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.transformRequest = [function(data){data = Qs.stringify(data); return data}];
Vue.prototype.axios = axios;
Vue.prototype.$toast = Toast;
Vue.prototype.$load = Indicator;
Vue.prototype.$wx = wx;
Vue.use(VueCookies)
Vue.use(VueAwesomeSwiper)
Vue.use(VueTouch, {name: 'v-touch'})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




router.beforeEach((to, from, next) => {
	console.log('准备to',to);
	if(!store.state.isUpdate){
		// if(localStorage.getItem('pclogin') == 492 | to.fullPath==='/webhome'){
			next();
		// }else{
		// 	if(to.fullPath==='/weblogin'){
		//         next();
		//     }else{
		//         next('/weblogin');
		//     }

		// }
	}else{
		if(to.fullPath==='/updatepage'){
		        next();
	    }else{
	        next('/updatepage');
	    }
	}
})
